import * as yup from 'yup';

export const configureLimitsSchema = yup.object().shape({
  entityLimit: yup.number().required('Required'),
});
